import React from "react";
import styles from "./ProfileCard.module.scss";
import { count } from "console";
import { useTranslation } from "react-i18next";
import { useAppSelector } from "../../../redux/hooks";
import Icon from "../../common/Icon/Icon";
import CountryFlag from "../../../utils/countryFlags";
import { getCountryNameFromCode } from "../../../utils/awardIconMapping";

interface ProfileCardProps {
  aboNumber: string;
  businessName: string;
  countryCode: string;
  award: string;
  isPrimary?: boolean;
}
const ProfileCard: React.FC<ProfileCardProps> = ({
  aboNumber,
  businessName,
  countryCode,
  award,
  isPrimary = false,
}) => {
  const { t } = useTranslation();
  const currentTheme = useAppSelector((state: any) => state.theme.currentTheme);

  return (
    <div className={styles.card_wrapper}>
      <div className={styles.abo_row}>
        <span className={styles.abo_number}>{aboNumber}</span>
        <span className={styles.business_name}>{businessName}</span>
      </div>

      <div className={styles.country_row}>
        <div className={styles.country_wrapper}>
          <span className={styles.country_flag}>
            <CountryFlag countryCode={countryCode} />
          </span>
          <span className={styles.country_name}>
            {getCountryNameFromCode(countryCode, t)}
          </span>
        </div>

        {isPrimary && (
          <div className={styles.primary_wrapper}>
            <Icon
              name="primary_icon"
              size={17}
              color={currentTheme === "light" ? "#5969D6" : "#99B2F5"}
              className={styles.search_icon}
            />
            <span className={styles.primary_text}>
              {t("contact_info.primary")}
            </span>
          </div>
        )}
      </div>

      <div className={styles.divider}></div>

      <div className={styles.award_row}>
        <span className={styles.current_award}>{t("currentAward")}</span>
        <span className={styles.award_name}>{award}</span>
      </div>
    </div>
  );
};

export default ProfileCard;
